

























import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { ExStore } from 'vuex'

@Component({
  components: {
    FileInput: () => import('@/components/common/inputs/FileInput.vue'),
    Modal: () => import('@/components/common/modals/Modal.vue')
  }
})
export default class ImageUpload extends Vue {
  fileSelect = false

  @Watch('fileBase64')
  onChangeFile(base64: string) {
    if (!base64) this.$router.replace({ name: 'Hangup' })
    this.$router.push({ name: 'PatientImageCreate' })
  }

  get file() {
    return this.$store.getters['image/patientUploadImage']
  }

  set file(file: { name: string; base64: string }) {
    this.$store.dispatch('image/updatePatientUploadImage', file)
  }

  get fileName() {
    return this.file.name
  }

  set fileName(name: string) {
    this.file = { name, base64: this.fileBase64 }
  }

  get fileBase64() {
    return this.file.base64
  }

  set fileBase64(base64: string) {
    this.file = { name: this.fileName, base64 }
  }

  get user() {
    return this.$store.getters['user/userInfo']
  }

  async created() {
    await this.checkIsValidLogin()
    this.$store.dispatch('image/setIsInAppBrowser', true)
  }

  handleModalClose() {
    this.$router.replace({ name: 'Hangup' })
  }

  handleFileInputClick() {
    this.fileSelect = true
  }

  async checkIsValidLogin() {
    try {
      await this.$api.user.fetch()
    } catch (e) {
      this.$store.dispatch('alert/showErrorMessages', ['エラーが発生しました'])
      this.$router.replace({ name: 'Hangup' })
    }
  }
}
